import http from "./http-common"
import {getData, postData} from "../handlers";

export default class CatalogServices {
    static categories = {
        index: (queryString) => {
            return getData(http, `/app/catalog/categories${queryString ? `?${queryString}` : ""}`);
        },
        indexIds: (queryString) => {
            let params = ''
            if(queryString){
                queryString.forEach(element => {
                    params += `ids[]=${element}&`
                });
            }
            return getData(http, `/app/catalog/categories/without-subcategories${params ? `?${params}` : ""}`);
        },
        view: (slug, queryString) => {
            return getData(http, `/app/catalog/categories/${slug}${queryString ? `?${queryString}` : ""}`);
        }
    }

    static products = {
        index: (queryString) => {
            return getData(http, `/app/catalog/products${queryString ? `?${queryString}` : ""}`);
        },

        latestProducts: () => {
            return getData(http, `/app/catalog/products`);
        },

        view: (slug, queryString) => {
            return getData(http, `/app/catalog/products/${slug}${queryString ? `?${queryString}` : ""}`);
        }
    }
}